module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/setplan-1-2b2e0e8d17d1c7d4455f92747dde5e30.png";